<template>
  <b-row>
    <b-col lg="3" md="3" sm="12" order="1">
      <b-card class="sticky-card">
        <h5 class="kb-title">
          <b-icon icon="info-circle" class="mr-1" />
          Covered Topics
        </h5>
        <vue-perfect-scrollbar :settings="scrollSettings" class="scroll-style">
          <ul class="mt-1 v-list">
            <li v-for="(topic, index) in relatedTopics" :key="index" class="ml-n2">
              <b-link :href="`#${topic.href}`" class="list-item">{{ topic.name }}</b-link>
            </li>
          </ul>
        </vue-perfect-scrollbar>
      </b-card>
    </b-col>
    <b-col lg="9" md="9" sm="12" order="2">
      <b-card>
        <h1 class="mb-1" align="center">xVisor Web Portal</h1>
        <div id="Content" class="question-content">
          <WebPortalContent></WebPortalContent>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

import WebPortalContent from '@/xvisor/views/knowledgeBase/components/WebPortalContent.vue';

export default {
  components: {
    VuePerfectScrollbar,
    WebPortalContent,
  },
  data() {
    return {
      scrollSettings: {
        maxScrollbarLength: 50,
      },
      relatedTopics: [
        { name: 'Ennetix xVisor Web Portal', href: 'ennetix-xvisor-web-portal' },
        { name: 'Sign Up and Login', href: '1-sign-up-and-log-in' },
        { name: 'Overview Page', href: '2-overview-page' },
        { name: 'Add XOME', href: '2-1-add-xome' },
        { name: 'Rest of Overview Page', href: '2-2-rest-of-overview-page' },
        { name: 'Add Custom Application', href: '2-3-add-custom-application' },
        { name: 'Reports Page', href: '3-reports-page' },
        { name: 'Settings Page', href: '4-settings-page' },
        { name: 'System Tab', href: '4-1-system-tab' },
        { name: 'XOMEs Tab', href: '4-2-xome-s-tab' },
        { name: 'Users Tab', href: '4-3-user-s-tab' },
        { name: 'Teams Tab', href: '4-4-team-s-tab' },
        { name: 'Offices Zones Tab', href: '4-5-offices-zones-tab' },
        { name: 'Maintenance Tab', href: '4-6-maintenance-tab' },
        { name: 'Security Tab', href: '4-7-security-tab' },
        { name: 'Reports Tab', href: '4-8-reports-tab' },
        { name: 'Activity Logs', href: '4-9-activity-logs' },
        { name: 'User Profile Page', href: '5-user-profile-page' },
        { name: 'Reset Password', href: '5-1-reset-password' },
        { name: 'Status Page', href: '6-status-page' },
      ],
    };
  },
};
</script>
